import { EventOrderModel } from "../../models/EventOrderModel";
import { BottomPane } from "@shop/frontend/web/js/components/BottomPane";
import api from "@shop/frontend/web/js/api";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { Modal } from "@shop/frontend/web/js/components/Modal";

import { EventOrderView } from "./EventOrderView";

export class EventOrderBottom extends BottomPane {
	constructor() {
		super();

		this.isDesktopLG = window.matchMedia("(max-width: 1250px)");
		this.isDesktopMD = window.matchMedia("(max-width: 1024px)");
		this.isDesktopSM = window.matchMedia("(max-width: 768px)");
		this.isDesktop = window.matchMedia("(min-width: 768px)");
		this.model = new EventOrderModel();
		this.view = new EventOrderView();
		this.modal = new Modal();
		this.init();
	}

	init() {
		this.pane("expanded", () => this.view.$tickets.show());
		this.pane("reduced", () => this.view.$tickets.hide());

		this.setUpListeners();
		this.initPriceLoyaltyCategories();
	}

	setUpListeners() {
		$(document).on("click", ".js-tickets-remove", e => {
			const sid = $(e.currentTarget).parents(".ticket-item").attr("data-place");
			const uid = $(e.currentTarget).parents(".ticket-item").attr("data-uid");
			const priceId = $(e.currentTarget).parents(".ticket-item").attr("data-price-id");
			this.emitter.emit("event:remove-from-cart", { sid, uid, priceId });
		});
		$(document).on("click", "#js-order-clear", e => this.emitter.emit("event:clear-order"));
		if (this.isDesktop.matches) {
			$(document).on('mouseenter', ".ticket-item_large", e => {
				if (this.isDesktopSM.matches) {
					$(e.currentTarget).nextAll().css('transition-duration',  "0.4s");
					$(e.currentTarget).nextAll().css("transform", "translateX(80%)");
					return
				}
				if (this.isDesktopMD.matches) {
					$(e.currentTarget).nextAll().css('transition-duration',  "0.4s");
					$(e.currentTarget).nextAll().css("transform", "translateX(30%)");
					return
				}
				$(e.currentTarget).nextAll().css('transition-duration',  "0.4s");
				$(e.currentTarget).nextAll().css("transform", "translateX(50%)");

			}).on("mouseleave",".ticket-item_large", e => {
				$(e.currentTarget).nextAll().css('transition-duration',  "0.4s");
				$(e.currentTarget).nextAll().css("transform", "translateX(0px)");
			})
		}
	}

	/* event listeners */
	on(action, fn) {
		/** @event EventOrderBottom#event:clear-order */
		if (action === "clear") this.emitter.subscribe("event:clear-order", () => fn());

		/** @event EventOrderBottom#event:remove-from-cart */
		if (action === "remove-ticket")
			this.emitter.subscribe("event:remove-from-cart", ({ sid, uid, priceId }) =>
				fn({
					sid,
					uid,
					priceId,
				})
			);
	}

	/**
	 * Функция для обновления заказа
	 * Если передать id мероприятия то будет сортировать под конкретное мероприятие! т.к в заказе могут быть несколько мероприятий
	 * @param orderData {Object} - Объект заказа полученный из сервера
	 * @param eventId
	 */
	updateOrder(orderData = {}, eventId = null, activeCarts = null) {
		/* Обновление лояльных категорий, без обновления заказа */
		if (activeCarts) {
			this.model.updateCategoriesActiveCarts(activeCarts);
			this.view.render(this.model.getOrderData());
			return this.show();
		}
		
		/* валидируем заказ полученный из сервера */
		if (orderData && orderData.carts) this.model.validateOrderData(orderData, eventId);
		this.view.render(this.model.getOrderData());

		/* Если заказ пустой то скрываем его */
		if (!this.model.carts.length > 0) return this.hide();

		return this.show();
	}

	clearOrder() {
		this.model.initOrder();

		return this.updateOrder();
	}

	removeActiveCarts(carts, activeCarts = {}) {
		this.model.removeActiveCarts(carts);

		if (activeCarts) {
			return this.updateOrder({}, null, activeCarts);
		}
		return this.updateOrder();
	}

	getOrderCarts() {
		return this.model.carts ? this.model.carts : [];
	}

	getOrderId() {
		return this.model.id ? this.model.id : null;
	}

	enableBtn() {
		this.view.$placesBuy.removeClass("inactive");
	}

	disableBtn() {
		this.view.$placesBuy.addClass("inactive");
	}

	initPriceLoyaltyCategories() {
		$(document).on("change", ".price-category-select input", e => {
			const $input = $(e.currentTarget);
			const orderId = this.model.id;
			const eventId = $input.parents(".ticket-item").data("event");
			const uid = $input.parents(".ticket-item").data("uid");
			const priceId = $input.val();
			const categoryId = $input.data("category-id");
			const inputName = $input.data("name");

			function setActiveItem(uid, name, price) {
				const ticket = $(`.ticket-item[data-uid="${uid}"]`);
				const select = ticket.find(".price-category-select");
				const dropdowns = ticket.find(".dropdown__item");

				ticket.find('.js-ticket-price').text(price);
				dropdowns.each((i, dropdown) => {
					const currentDropdownInput = $(dropdown).find("input");
					if ($(dropdown).text().trim() !== name) {
						currentDropdownInput.prop('checked', false); 
					} else {
						currentDropdownInput.prop('checked', true); 
						currentDropdownInput.data('name', inputName);
					}
				})
			}

			function cancelSelect(uid) {
				const ticket = $(`.ticket-item[data-uid="${uid}"]`);
				const select = ticket.find(".price-category-select");
				const name = select.find("input").data('name');

				const line = select.find(".dropdown__list .dropdown__item");
				select.find("input").prop("checked", false);
				line.each((i, item) => {
					const currentName = $(item).find(".js-price-category-select-line-name").text();
					if (currentName == name) {
						$(item).find("input").prop("checked", true);
					}
				});
			}
			
			api.eventCart
				.changePriceId({ eventId, orderId, uid, priceId, categoryId })
				.then(res => {
					if (res.error) throw new Error(res.msg || "");

					this.model.updateOrderAmount(res.summ);
					let currentCart = res.carts.find(item => item.uid == uid);
					currentCart = res.active_carts[eventId].carts.find(
						item => item.id === currentCart.id
					);

					this.model.updateCategoriesActiveCarts(res.carts);
					setActiveItem(uid);

					$('#js-event-sum').text(res.active_carts[eventId].summ)
					this.model.carts.find(item => item.uid == uid).price = currentCart.price;
					const price = this.model.carts.find(item => item.uid == uid).price	
					setActiveItem(uid, inputName, price);
				})
				.catch(err => {
					console.log(err);
					if (err.message && err.message === "Требуется хотя бы один взрослый билет!") {
						alert(`${err.message}`);
						cancelSelect(uid);
						return false;
					}
					this.modal.show(
						`
						${translator.t("main", "An error occurred!")}
						<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});
	}
}
